define('models/accounts/accountattribute_collection',["backbone",
        "models/accounts/accountattribute"
], function (Backbone, AccountAttributeItem) {
    var AccountAttributeList = Backbone.Collection.extend({
        url: function () {

            if (this.instanceURL)
                return this.instanceURL;
            var url = pf.consumerURL;
            //if (this.ID != null) {
            //    url += "/" + this.ID;
            //}
            return url;
        },
        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;

        },
        model: AccountAttributeItem
    });
    return AccountAttributeList;
});
